<template>
    <fieldset v-if="enabled">
        <legend>Конкуренты</legend>
        <table style="width:100%;">
            <thead>
                <tr>
                    <th style="width:199px">Конкурент</th>
                    <th>Старое <small class="stt">({{isMac}} + click чтобы открыть / кликнуть чтобы выбрать)</small></th>
                    <th>Новое <small class="stt">({{isMac}} + click чтобы открыть / кликнуть чтобы выбрать)</small></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(url, i) in competitorUrlsConflicts">
                    <td>{{ getNameById(url.competitor_id) }}:</td>
                    <td :class="{selected : isSelectedFrom(url)}"><a @click.prevent="selectUrl($event, url)">{{ url.from_url }}</a></td>
                    <td :class="{selected : isSelectedTo(url)}"><a @click.prevent="selectUrl($event, url)">{{ url.to_url }}</a>
                    </td>
                </tr>
            </tbody>
        </table>
    </fieldset>
</template>

<script>
    export default {
        props: {
            competitorUrlsConflicts: Array,
            competitors: Array,
        },
        data: () => ({
            selectedUrls: [],
        }),
        methods: {
            selectUrl(event, url) {
                if (event.altKey) {
                    window.open(event.target.innerText, '_blank')
                    return
                }
                this.selectedUrls = this.selectedUrls.filter(function (urlConflict) {
                    return urlConflict.id !== url.competitor_id
                })
                console.log(event, url)

                this.selectedUrls.push({id: url.competitor_id, url: event.target.innerText})

                if (this.competitorUrlsConflicts.length === this.selectedUrls.length) {
                    this.$emit('url-conflicts-resolved', this.selectedUrls)
                }
            },
            getNameById(id) {
                return this.competitors.find(competitor => competitor.id === id).name
            },
            isSelectedFrom(url) {
                return this.selectedUrls.some(selectedUrl => selectedUrl.url === url.from_url)
            },
            isSelectedTo(url) {
                return this.selectedUrls.some(selectedUrl => selectedUrl.url === url.to_url)
            }
        },
        computed: {
            enabled() {
                return this.competitorUrlsConflicts && this.competitorUrlsConflicts.length > 0;
            },
            isMac() {
                let macosPlatforms = /(macintosh|macintel|macppc|mac68k|macos)/i
                if (macosPlatforms.test(window.navigator.userAgent.toLowerCase())) {
                    return 'option'
                }
                return 'alt'
            },
        }
    }
</script>
<style scoped>
    .stt {
        color: darkgray;
        text-decoration: none;
        font-weight: lighter;
    }
    .selected {
        background-color: #f6fff2;
        font-weight: bolder;
    }
</style>
